import {useEffect} from 'react';
//components
import {
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from '@material-ui/core';
//style
import classes from './videoCard.module.css';

//utils
import {translateVideosName} from '../../../utils/helpers';

const VideoCard = (props: any) => {
  useEffect(() => {
    window.scrollTo(0, 855);
  }, [props.selectCategoryHandler]);

  //JSX
  return (
    <Card
      onClick={() => {
        props.selectCategoryHandler(props.videoObj);
      }}
      className={classes.container}
    >
      <img src="/video/play.svg" className={classes.playIcon} />
      <CardMedia
        component="img"
        height="150"
        src={`/video/${props.videoObj[0]}.svg`}
        alt="partner"
        className={classes.cardMedia}
      />
      <CardContent>
        <Grid xs={12}>
          <Typography variant="body2">
            {translateVideosName(props.videoObj[0])}
          </Typography>
        </Grid>
        <Grid className={classes.content} xs={12} container>
          <Grid xs={6} item>
            <span>
              <b className={classes.time}>{`${Math.round(
                props.videoObj[1].categoryVideoLength / 60
              )}`}</b>
              &nbsp;
              {`دقیقه`}
            </span>
          </Grid>
          <Grid className={classes.count} xs={6} item>
            <span>
              <b>{`${props.videoObj[1].videos.length}`}</b>
              &nbsp;
              {`ویدیو`}
            </span>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default VideoCard;
